import React, { useEffect, useState } from 'react';
import style from "./css/Notification.module.css";
import { apiURL_BACKEND, NotificationInterface } from './Vars';
import axios from 'axios';
interface NotificationProps {
 messages:NotificationInterface[] | null
}




const Notification: React.FC<NotificationProps> = ({messages}) => {
    const [notifications, setNotifications] = useState<NotificationInterface[]>([]);

    const removeMessage = (id: number) => {
        setNotifications((prev) => prev.filter((msg) => msg.id !== id));
      };

    useEffect(()=>{
        if(messages){
            const allNotifications = [...notifications,...messages]
            const newList:NotificationInterface[] = []
            allNotifications.map((notification_,index)=>{
                let n = notification_;
                n.id = index;
                newList.push(n);
            })
            setNotifications(newList);
        }
        axios.get(`${apiURL_BACKEND}/getNotifications/`).then((res)=>{
            console.log(res.data);
        })


    },[])
    return (
        <>
            <div className={style.notifications}>
                <div className={style.notification}>
                    {

                        notifications.map((msg) => {
                            return <>
                                <div className={style.success}>
                                    <p>{msg.text}</p>
                                    <button onClick={(e)=>{e.preventDefault(); removeMessage(msg.id);}}><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                        <path d="M8 23.75L6.25 22L13.25 15L6.25 8L8 6.25L15 13.25L22 6.25L23.75 8L16.75 15L23.75 22L22 23.75L15 16.75L8 23.75Z" fill="white" />
                                    </svg></button>
                                </div>
                            </>
                        })

                    }

                </div>
            </div>
        </>
    );
};

export default Notification;